import { PublicKey } from '@solana/web3.js';
import { buildRedeemSolverTx } from './buildRedeemSolverTx.js';
export async function redeemSolver(connection, signer, params, program) {
    const walletPublicKey = new PublicKey(signer.publicKey);
    const tx = await buildRedeemSolverTx(connection, program, walletPublicKey, params);
    try {
        const signature = await signer.sendTransaction(tx);
        const res = await connection.confirmTransaction({
            blockhash: tx.recentBlockhash,
            lastValidBlockHeight: tx.lastValidBlockHeight,
            signature,
        });
        if (res?.value.err) {
            throw new Error(res.value.err.toString());
        }
        return signature;
    }
    catch (error) {
        console.error('Error in redeemSolver:', error);
        throw error;
    }
}
